import { render } from "./SampleDocuments.vue?vue&type=template&id=f9940c94&scoped=true"
import script from "./SampleDocuments.vue?vue&type=script&lang=js"
export * from "./SampleDocuments.vue?vue&type=script&lang=js"

import "./SampleDocuments.vue?vue&type=style&index=0&id=f9940c94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9940c94"]])

export default __exports__